<template>
    <FormModal ref="modal" :model="model" :init="init" modal-id="listing" :beforeSaving="beforeSaving" :onSetIsEditMode="onSetIsEditMode" @save="$emit('save', $event)" @destroy="$emit('destroy', $event)" :is-enabled-view-mode="false" :hide-footer="true" @shown="onShown">
        <template>
            <div :key="key" class="d-flex">
                <ItemBadges :model="model" class="mb-1" />
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <b-row>
                    <b-col lg="12">
                        <b-form-checkbox v-model="model._.load_last_listing" switch size="lg" class="mb-3" @change="onChangeLoadLastListing">
                            前回出品した設定読込
                        </b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12">
                        <b-card class="mb-3" no-body>
                            <b-card-header @click="model._.step_1_open = !model._.step_1_open" role="button" class="d-flex justify-content-between">
                                <strong>Step.1 カタログ</strong>
                                <small>クリック開閉</small>
                            </b-card-header>
                            <b-collapse id="step-1" v-model="model._.step_1_open">
                                <b-card-body>
                                    <h6 class="font-weight-bold">商品カテゴリ</h6>
                                    <ItemCategory
                                        ref="itemCategory"
                                        provider="ebay"
                                        v-model="model.values.ebay.category_id"
                                        @input="onInputCategoryId"
                                        />

                                    <div class="border-top my-4"></div>

                                    <h6 class="font-weight-bold">商品の詳細</h6>
                                    <ItemSpecifics
                                        ref="itemSpecifics"
                                        provider="ebay"
                                        v-model="model.values.ebay.item_specifics"
                                        @input=""
                                        />
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </b-col>
                    <b-col lg="6">
                        <b-card class="mb-3" no-body>
                            <b-card-header class="d-flex justify-content-between">
                                <strong>Step.2 出品</strong>
                            </b-card-header>
                            <b-collapse id="step-2" visible>
                                <b-card-body>
                                    <h6 class="font-weight-bold">タイトル</h6>
                                    <b-form-input v-model="model.values.ebay.title" placeholder="title"></b-form-input>

                                    <div class="border-top my-4"></div>

                                    <h6 class="font-weight-bold">SKU</h6>

                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>任意SKU</th>
                                                <td>
                                                    <b-form-input
                                                        v-model="ebay.sku_prefix"
                                                        type="text"
                                                        @input="buildSku"
                                                        />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>通し番号</th>
                                                <td>
                                                    <b-form-input
                                                        v-model="ebay.sku_number"
                                                        type="number"
                                                        @input="buildSku"
                                                        />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>仕入原価</th>
                                                <td>
                                                    <b-form-input
                                                        v-model="ebay.sku_cost"
                                                        type="number"
                                                        @input="buildSku"
                                                        />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>SKU</th>
                                                <td>
                                                    <strong>{{ model.values.ebay.sku }}</strong>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
<!--
                                    <b-form-input v-model="model.values.ebay.sku" placeholder=""></b-form-input>
                                    <div class="text-secondary">
                                        末尾が「半角ハイフン+半角数字」がおすすめです。「コピー出品」機能でSKUの末尾の数字が自動で+1されるので便利です。 例）TSKYABC-0001
                                    </div>
-->

                                    <div class="border-top my-4"></div>


                                    <h6 class="font-weight-bold">写真</h6>
                                    <FileImageDrop
                                        v-model="model.values.ebay.picture_details.picture_url"
                                        />

                                    <!--
                                    <input-error :errors="error.values.ebay.photos" />
                                    -->

                                    <div class="border-top my-4"></div>

                                    <h6 class="font-weight-bold">説明</h6>
                                    <b-form-textarea
                                        v-model="model.values.ebay.description"
                                        placeholder="商品の詳しい説明を書きましょう。"
                                        rows="3"
                                        max-rows="6"
                                        v-b-modal="'modal-values-ebay-description'"
                                        />
                                    <b-modal
                                        id="modal-values-ebay-description"
                                        ok-only
                                        title="説明"
                                        size="xl"
                                        >
                                        <HtmlEditorWzPreview v-model="model.values.ebay.description" />

<!--
                                        <b-row>
                                            <b-col lg="6">
                                                エディタ
                                                <b-form-textarea
                                                    v-model="model.values.ebay.description"
                                                    placeholder="商品の詳しい説明を書きましょう。"
                                                    class="min-vh-50 mb-3"
                                                    max-rows="9999"
                                                    />
                                            </b-col>
                                            <b-col lg="6">
                                                プレビュー ※クリックでプレビュー更新
                                                <div class="border rounded p-2 min-vh-50 mb-3" @click="onClickPreviewDescription" role="button" v-html="$data._.preview_description">
                                                </div>
                                            </b-col>
                                        </b-row>
-->
                                    </b-modal>

                                    <div class="border-top my-4"></div>

                                    <h6 class="font-weight-bold">状態</h6>
                                    <div>{{ trans.ebay_labels[model.values.ebay.category_id + '.condition_id'] || '商品の状態' }}</div>
                                    <SelectBase
                                        v-model="model.values.ebay.condition_id"
                                        :options="ebay.conditions"
                                        :getOptionLabel="(option) => { return trans.ebay_labels[model.values.ebay.category_id + '.condition_id.' + option.value] || option.text }"
                                        @input="onInputConditionId"
                                        />
                                    <div v-for="condition_descriptor in model.values.ebay.condition_descriptors">
                                        <div class="mt-2">{{ trans.ebay_labels[model.values.ebay.category_id + '.condition_id.' + model.values.ebay.condition_id + '.' + condition_descriptor.conditionDescriptorId] || condition_descriptor.conditionDescriptorName }}</div>
                                        <template v-if="condition_descriptor.conditionDescriptorValues">
                                            <SelectBase
                                                v-model="condition_descriptor.value"
                                                :options="condition_descriptor.conditionDescriptorValues"
                                                :reduce="(option) => { return option.conditionDescriptorValueId }"
                                                :getOptionLabel="(option) => { return trans.ebay_labels[model.values.ebay.category_id + '.condition_id.' + model.values.ebay.condition_id + '.' + condition_descriptor.conditionDescriptorId + '.' + option.conditionDescriptorValueId] || option.conditionDescriptorValueName }"
                                                />
                                        </template>
                                        <template v-else>
                                            <b-form-input type="text" v-model="condition_descriptor.value" />
                                        </template>
                                    </div>

<!--
                                    <div class="mt-2">状態の説明 ※商品の状態「New」以外の時に有効</div>
                                    <b-form-textarea
                                        v-model="model.values.ebay.condition_description"
                                        placeholder="面白い機能や欠陥など、商品のユニークな特徴を購入者に知らせましょう。"
                                        rows="3"
                                        max-rows="6"
                                        />
-->

                                    <div class="border-top my-4"></div>

                                    <h6 class="font-weight-bold">価格</h6>
                                    <div class="">形式</div>
                                    <SelectBase
                                        v-model="model.values.ebay.listing_type"
                                        :options="ebay.listing_types"
                                        @input="model.values.ebay.quantity = model.values.ebay.listing_type === 'Chinese' ? 1 : model.values.ebay.quantity"
                                        />
                                    <template v-if="model.values.ebay.listing_type === 'Chinese'">
                                        <div class="mt-2">オークションの期間</div>
                                        <SelectBase
                                            v-model="model.values.ebay.listing_duration"
                                            :options="(ebay.listing_durations && ebay.listing_durations[model.values.ebay.listing_type]) ? ebay.listing_durations[model.values.ebay.listing_type].value.Duration : []"
                                            :reduce="(option) => { return option }"
                                            :getOptionLabel="(option) => { return option }"
                                            />
                                        <div class="text-secondary">
                                            Day_1は、出品者のフィードバックスコア、オークション形式、カテゴリタイプなど、いくつかの条件を満たす必要があります。
                                        </div>
                                        <b-row class="mt-2 mb-3">
                                            <b-col cols="12" sm="6">
                                                開始入札価格
                                                <b-input-group
                                                    >
                                                    <b-form-input
                                                        v-model="model.values.ebay.start_price"
                                                        class="text-right no-spin"
                                                        type="number"
                                                        placeholder=""
                                                        />
                                                    <b-input-group-append>
                                                        <span class="input-group-text"> 
                                                            USD
                                                        </span> 
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-col>
                                            <b-col cols="12" sm="6">
                                                今すぐ落札(任意)
                                                <b-input-group
                                                    >
                                                    <b-form-input
                                                        v-model="model.values.ebay.buy_it_now_price"
                                                        class="text-right no-spin"
                                                        type="number"
                                                        placeholder=""
                                                        />
                                                    <b-input-group-append>
                                                        <span class="input-group-text"> 
                                                            USD
                                                        </span> 
                                                    </b-input-group-append>
                                                </b-input-group>
                                                <div class="text-secondary">
                                                    最低額：
                                                    <span v-if="!model.values.ebay.start_price">開始入札価格に30%を加えた額</span>
                                                    <span v-if="model.values.ebay.start_price">${{ (Math.ceil(model.values.ebay.start_price * 1.3 * 100) / 100).toFixed(2) }} <a @click="model.values.ebay.buy_it_now_price = (Math.ceil(model.values.ebay.start_price * 1.3 * 100) / 100).toFixed(2)" href="javascript:void(0)">適用</a></span>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <div class="mt-2">
                                            <b-form-checkbox
                                                v-model="model.values.ebay.auto_pay"
                                                :value="true"
                                                :unchecked-value="false"
                                                >
                                                購入者が今すぐ落札を使うときはすぐに支払いを要求
                                            </b-form-checkbox>
                                        </div>
                                        <div class="mt-2">最低落札価格(任意) — 手数料がかかります</div>
                                        <b-form-input type="number" v-model="model.values.ebay.reserve_price"></b-form-input>
                                        <div class="mt-2">数量</div>
                                        <b-form-input type="number" v-model="model.values.ebay.quantity" disabled></b-form-input>
                                    </template>

                                    <template v-if="model.values.ebay.listing_type === 'FixedPriceItem'">
                                        <div class="mt-2">商品価格</div>
                                        <b-form-input type="number" v-model="model.values.ebay.start_price"></b-form-input>
                                        <b-form-checkbox
                                            v-model="model.values.ebay.auto_pay"
                                            :value="true"
                                            :unchecked-value="false"
                                            class="mt-2"
                                            >
                                            購入者が今すぐ落札を使うときはすぐに支払いを要求
                                        </b-form-checkbox>

                                        <div class="mt-2">数量</div>
                                        <b-form-input type="number" v-model="model.values.ebay.quantity"></b-form-input>
                                    </template>

                                    <b-card
                                        class="mt-2"
                                        >
                                        <b-row>
                                            <b-col>
                                                <h6 class="font-weight-bold">オファーを許可</h6>
                                            </b-col>
                                            <b-col cols="auto">
                                                <b-form-checkbox v-model="model.values.ebay.best_offer_details.best_offer_enabled" switch />
                                            </b-col>
                                        </b-row>
                                        <template v-if="model.values.ebay.best_offer_details.best_offer_enabled">
                                            <b-row>
                                                <b-col>
                                                    最低オファー(任意)
                                                    <b-form-input type="number" v-model="model.values.ebay.listing_details.minimum_best_offer_price"></b-form-input>
                                                </b-col>
                                                <b-col>
                                                    自動承認(任意)
                                                    <b-form-input type="number" v-model="model.values.ebay.listing_details.best_offer_auto_accept_price"></b-form-input>
                                                </b-col>
                                            </b-row>
                                        </template>
                                    </b-card>

                                    <b-card
                                        class="mt-2"
                                        >
                                        <b-row>
                                            <b-col>
                                                <h6 class="font-weight-bold">出品日時を指定</h6>
                                            </b-col>
                                            <b-col cols="auto">
                                                <b-form-checkbox v-model="model._.is_enabled_schedule" switch />
                                            </b-col>
                                        </b-row>
                                        <template v-if="model._.is_enabled_schedule">
                                            <b-row>
                                                <b-col>
                                                    タイムゾーン
                                                    <SelectBase
                                                        v-model="ebay.schedule_time_zone"
                                                        :options="ebay.time_zones"
                                                        @input="onInputEbayScheduleTimeZone"
                                                        />
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    日にち
                                                    <b-input-group class="mb-3">
                                                        <b-form-input
                                                            v-model="ebay.schedule_time_date"
                                                            type="text"
                                                            placeholder="YYYY-MM-DD"
                                                            autocomplete="off"
                                                            ></b-form-input>
                                                        <b-input-group-append>
                                                            <b-form-datepicker
                                                                v-model="ebay.schedule_time_date"
                                                                button-only
                                                                right
                                                                :start-weekday="1"
                                                                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow', }"
                                                                @context="onContextEbayScheduleTimeDate"
                                                                />
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-col>
                                                <b-col>
                                                    時間
                                                    <b-input-group class="mb-3">
                                                        <b-form-input
                                                            v-model="ebay.schedule_time_time"
                                                            type="text"
                                                            placeholder="HH:mm"
                                                            />
                                                        <b-input-group-append>
                                                            <b-form-timepicker
                                                                v-model="ebay.schedule_time_time"
                                                                button-only
                                                                right
                                                                locale="en"
                                                                :hour12="false"
                                                                @context="onContextEbayScheduleTimeTime"
                                                                />
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-col>
                                            </b-row>
                                            <div class="text-right">
                                                {{ model.values.ebay.schedule_time | BaseDatetimeFormatter('+0900') }}
                                                (日本時間)
                                                <br>
<!--
                                                <a href="#" @click="onClickScheduledOffset(response.ScheduledList.ItemArray.Item[index], 15)">+15秒</a>
                                                <a href="#" @click="onClickScheduledOffset(response.ScheduledList.ItemArray.Item[index], 30)">+30秒</a>
                                                <a href="#" @click="onClickScheduledOffset(response.ScheduledList.ItemArray.Item[index], 60)">+60秒</a>
-->
                                                <template v-for="seconds in [ 15, 30, 60, ]">
                                                    &nbsp;<a href="#" @click="model.values.ebay.schedule_time = $moment(model.values.ebay.schedule_time).add(seconds, 'seconds').utcOffset(ebay.schedule_time_zone); parseEbayScheduleTime(model.values.ebay.schedule_time);">+{{ seconds }}秒</a>
                                                </template>
                                                <br>
                                                <a href="#" @click="onClickScheduledOffset($data._.schedule_time_default)">2日後20時</a>
                                            </div>

                                            <span
                                                class="text-danger"
                                                v-if="!model.values.ebay.schedule_time"
                                                >
                                                有効な日時を入力してください。
                                            </span>
<!--
                                            <h6 class="font-weight-bold mt-3">予約出品一覧からかんたん設定</h6>
                                            <template v-if="response.ScheduledList && response.ScheduledList.ItemArray && response.ScheduledList.ItemArray.Item">
                                                <div v-for="(item, index) in response.ScheduledList.ItemArray.Item">
                                                    <MeListingListItem
                                                        v-model="response.ScheduledList.ItemArray.Item[index]"
                                                        :timezone="ebay.schedule_time_zone"
                                                    >
                                                        <template v-slot:link>
                                                            <a href="#" @click="onClickScheduledOffset(response.ScheduledList.ItemArray.Item[index], 15)">+15秒</a>
                                                            <a href="#" @click="onClickScheduledOffset(response.ScheduledList.ItemArray.Item[index], 30)">+30秒</a>
                                                            <a href="#" @click="onClickScheduledOffset(response.ScheduledList.ItemArray.Item[index], 60)">+60秒</a>
                                                        </template>
                                                    </MeListingListItem>
                                                </div>
                                            </template>
-->
                                        </template>
                                    </b-card>

                                    <div class="border-top my-4"></div>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </b-col>
                    <b-col lg="6">
                        <b-card class="mb-3" no-body>
                            <b-card-header class="d-flex justify-content-between">
                                <strong>Step.3 配送</strong>
<!--
                                <div class="text-right">
                                    <small>
                                        <a href="javascript:void(0)" @click="loadPolicyForStep3()">eBay設定読込</a>
                                    </small>
                                </div>
-->
                            </b-card-header>
                            <b-collapse id="step-3" visible>
                                <b-card-body>
                                    <h6 class="font-weight-bold">配送</h6>
<!--
                                    <div>配送方法</div>
                                    <SelectBase
                                        v-model="model.values.ebay.shipping_details.shipping_type"
                                        :options="ebay.shipping_types"
                                        />
-->
<!--
                                    <div class="mt-2">梱包重量(任意)</div>
                                    <b-input-group class="">
                                        <b-form-input
                                            v-model.number="model.values.ebay.shipping_package_details.weight_major"
                                            type="number"
                                            placeholder=""
                                            />
                                        <b-input-group-append>
                                            <span class="input-group-text"> 
                                                kg
                                            </span> 
                                        </b-input-group-append>
                                        <b-form-input
                                            v-model.number="model.values.ebay.shipping_package_details.weight_minor"
                                            type="number"
                                            placeholder=""
                                            />
                                        <b-input-group-append>
                                            <span class="input-group-text"> 
                                                gr
                                            </span> 
                                        </b-input-group-append>
                                    </b-input-group>
                                    <div class="text-secondary text-right">
                                        {{ gr2lbsoz(1000 * model.values.ebay.shipping_package_details.weight_major + model.values.ebay.shipping_package_details.weight_minor) }}
                                    </div>

                                    <div class="mt-2">梱包寸法(任意)</div>
                                    <b-input-group class="">
                                        <b-form-input
                                            v-model.number="model.values.ebay.shipping_package_details.package_depth"
                                            type="number"
                                            placeholder=""
                                            />
                                        <b-input-group-append>
                                            <span class="input-group-text"> 
                                                cm
                                            </span> 
                                        </b-input-group-append>
                                        <b-form-input
                                            v-model.number="model.values.ebay.shipping_package_details.package_length"
                                            type="number"
                                            placeholder=""
                                            />
                                        <b-input-group-append>
                                            <span class="input-group-text"> 
                                                cm
                                            </span> 
                                        </b-input-group-append>
                                        <b-form-input
                                            v-model.number="model.values.ebay.shipping_package_details.package_width"
                                            type="number"
                                            placeholder=""
                                            />
                                        <b-input-group-append>
                                            <span class="input-group-text"> 
                                                cm
                                            </span> 
                                        </b-input-group-append>
                                    </b-input-group>
                                    <div class="text-secondary text-right">
                                        {{ cm2inch(model.values.ebay.shipping_package_details.package_depth) }} inch x
                                        {{ cm2inch(model.values.ebay.shipping_package_details.package_length) }} inch x
                                        {{ cm2inch(model.values.ebay.shipping_package_details.package_width) }} inch
                                    </div>

                                    <div class="">
                                        <b-form-checkbox
                                            v-model="model.values.ebay.shipping_package_details.shipping_irregular"
                                            value="accepted"
                                            unchecked-value="not_accepted"
                                            >
                                            定形外梱包
                                        </b-form-checkbox>
                                    </div>
-->

                                    <div class="mt-4">US向け</div>
<!--
                                    <SelectBase
                                        v-model="model.values.ebay.shipping_details.domestic_shipping_type"
                                        :options="ebay.domestic_shipping_types"
                                        size="sm"
                                        />
-->
                                    <LogTable
                                        v-model="model.values.ebay.shipping_details.shipping_service_options"
                                        :fields="[
                                            { key: 'ship_to_location', label: '受取国', thStyle: { width: '10em', }, },
                                            { key: 'shipping_service', label: '配送サービス', thStyle: { width: 'auto', }, },
                                            { key: 'shipping_service_cost', label: '送料（1個目）', thStyle: { width: '10em', }, },
                                            { key: 'shipping_service_additional_cost', label: '送料(2個目～)', thStyle: { width: '10em', }, },
                                        ]"
                                        :defaultRow="{
                                            ship_to_location: [ 'US', ],
                                            shipping_service: null,
                                            shipping_service_cost: {
                                                value: null,
                                            },
                                            shipping_service_additional_cost: {
                                                value: null,
                                            },
                                        }"
                                        class="deal-items mt-2"
                                        :showBtnRowCopy="false"
                                        :showBtnRowMove="true"
                                        ref="logTableShippingDomestic"
                                        >
                                        <template v-slot:cell(ship_to_location)="data">
                                            {{ data.item.ship_to_location.join(',') }}
                                        </template>
                                        <template v-slot:cell(shipping_service)="data">
                                            <SelectBase
                                                v-model="data.item.shipping_service"
                                                :options="$store.state.app.data.shipping_services.filter((v) => { return v.value.InternationalService !== true && v.value.ServiceType.includes(model.values.ebay.shipping_details.domestic_shipping_type) }) || []"
                                                :reduce="v => v.code"
                                                :get-option-label="(option) => { return option.text + ' #' + option.value.ShippingServiceID + '#' }"
                                                size="sm"
                                                />
                                        </template>
                                        <template v-slot:cell(shipping_service_cost)="data">
                                            <b-input-group
                                                class=""
                                                size="sm"
                                                >
                                                <b-form-input
                                                    v-model="data.item.shipping_service_cost.value"
                                                    style="height:2.45em;"
                                                    @keydown="$refs.logTableShippingDomestic.keybindingForLogTable($event, data)"
                                                    @focus="$event.target.select()"
                                                    class="text-right no-spin"
                                                    placeholder=""
                                                    />
                                                <b-input-group-append>
                                                    <span class="input-group-text"> 
                                                        USD
                                                    </span> 
                                                </b-input-group-append>
                                            </b-input-group>
                                        </template>
                                        <template v-slot:cell(shipping_service_additional_cost)="data">
                                            <b-input-group
                                                class=""
                                                size="sm"
                                                >
                                                <b-form-input
                                                    v-model="data.item.shipping_service_additional_cost.value"
                                                    style="height:2.45em;"
                                                    @keydown="$refs.logTableShippingDomestic.keybindingForLogTable($event, data)"
                                                    @focus="$event.target.select()"
                                                    class="text-right no-spin"
                                                    placeholder=""
                                                    />
                                                <b-input-group-append>
                                                    <span class="input-group-text"> 
                                                        USD
                                                    </span> 
                                                </b-input-group-append>
                                            </b-input-group>
                                        </template>
                                    </LogTable>

                                    <div class="mt-4">US以外向け</div>
<!--
                                    <SelectBase
                                        v-model="model.values.ebay.shipping_details.international_shipping_type"
                                        :options="ebay.international_shipping_types"
                                        size="sm"
                                        />
-->
                                    <LogTable
                                        v-model="model.values.ebay.shipping_details.international_shipping_service_option"
                                        :fields="[
                                            { key: 'ship_to_location', label: '受取国', thStyle: { width: '10em', }, },
                                            { key: 'shipping_service', label: '配送サービス', thStyle: { width: 'auto', }, },
                                            { key: 'shipping_service_cost', label: '送料（1個目）', thStyle: { width: '10em', }, },
                                            { key: 'shipping_service_additional_cost', label: '送料(2個目～)', thStyle: { width: '10em', }, },
                                        ]"
                                        :defaultRow="{
                                            ship_to_location: [],
                                            shipping_service: null,
                                            shipping_service_cost: {
                                                value: null,
                                            },
                                            shipping_service_additional_cost: {
                                                value: null,
                                            },
                                        }"
                                        class="deal-items mt-2"
                                        :showBtnRowCopy="false"
                                        :showBtnRowMove="true"
                                        ref="logTableShippingInternational"
                                        >
                                        <template v-slot:cell(ship_to_location)="data">
                                            <SelectCountryRegion
                                                v-model="data.item.ship_to_location"
                                                :reduce="v => v.value"
                                                multiple
                                                />
                                        </template>
                                        <template v-slot:cell(shipping_service)="data">
                                            <SelectBase
                                                v-model="data.item.shipping_service"
                                                :options="$store.state.app.data.shipping_services.filter((v) => { return v.value.InternationalService === true && v.value.ServiceType.includes(model.values.ebay.shipping_details.international_shipping_type) }) || []"
                                                :reduce="v => v.code"
                                                :get-option-label="(option) => { return option.text + ' #' + option.value.ShippingServiceID + '#' }"
                                                size="sm"
                                                />
                                        </template>
                                        <template v-slot:cell(shipping_service_cost)="data">
                                            <b-input-group
                                                class=""
                                                size="sm"
                                                >
                                                <b-form-input
                                                    v-model="data.item.shipping_service_cost.value"
                                                    style="height:2.45em;"
                                                    @keydown="$refs.logTableShippingInternational.keybindingForLogTable($event, data)"
                                                    @focus="$event.target.select()"
                                                    class="text-right no-spin"
                                                    placeholder=""
                                                    />
                                                <b-input-group-append>
                                                    <span class="input-group-text"> 
                                                        USD
                                                    </span> 
                                                </b-input-group-append>
                                            </b-input-group>
                                        </template>
                                        <template v-slot:cell(shipping_service_additional_cost)="data">
                                            <b-input-group
                                                class=""
                                                size="sm"
                                                >
                                                <b-form-input
                                                    v-model="data.item.shipping_service_additional_cost.value"
                                                    style="height:2.45em;"
                                                    @keydown="$refs.logTableShippingInternational.keybindingForLogTable($event, data)"
                                                    @focus="$event.target.select()"
                                                    class="text-right no-spin"
                                                    placeholder=""
                                                    />
                                                <b-input-group-append>
                                                    <span class="input-group-text"> 
                                                        USD
                                                    </span> 
                                                </b-input-group-append>
                                            </b-input-group>
                                        </template>
                                    </LogTable>
                                    
                                    <div class="mt-4">環境設定</div>
                                    <b-card
                                        class=""
                                        >
                                        <h6 class="font-weight-bold">発送準備期間</h6>
                                        <SelectBase
                                            v-model="model.values.ebay.dispatch_time_max"
                                            :options="ebay.dispatch_time_max"
                                            size="sm"
                                            />

                                        <div class="border-top my-4"></div>

                                        <h6 class="font-weight-bold">発送元</h6>
                                        <div class="mt-2">国/地域</div>
                                        <SelectCountry
                                            v-model="model.values.ebay.country"
                                            :reduce="v => v.value"
                                            />
                                        <div class="mt-2">市区町村、州/都道府県</div>
                                        <b-form-input
                                            v-model="model.values.ebay.location"
                                            />

                                        <div class="border-top my-4"></div>

                                        <h6 class="font-weight-bold">返品</h6>
                                        <b-card
                                            class="mt-2"
                                            >
                                            <b-row>
                                                <b-col>
                                                    <h6 class="font-weight-bold">USで購入された商品の返品を許可</h6>
                                                </b-col>
                                                <b-col cols="auto">
                                                    <b-form-checkbox v-model="model.values.ebay.return_policy.returns_accepted_option" switch />
                                                </b-col>
                                            </b-row>
                                            <template v-if="model.values.ebay.return_policy.returns_accepted_option">
                                               <div class="mt-2">返品期限</div>
                                               <SelectBase
                                                   v-model="model.values.ebay.return_policy.returns_within_option"
                                                   :options="ebay.returns_within_options"
                                                   size="sm"
                                                   />

                                               <div class="mt-2">返送料負担</div>
                                               <SelectBase
                                                   v-model="model.values.ebay.return_policy.shipping_cost_paid_by_option"
                                                   :options="ebay.shipping_cost_paid_by_options"
                                                   size="sm"
                                                   />

                                               <div class="mt-2">返金方法</div>
                                               <SelectBase
                                                   v-model="model.values.ebay.return_policy.refund_option"
                                                   :options="ebay.refund_options"
                                                   size="sm"
                                                   />
                                            </template>
                                        </b-card>

                                        <b-card
                                            class="mt-2"
                                            >
                                            <b-row>
                                                <b-col>
                                                    <h6 class="font-weight-bold">US以外で購入された商品の返品を許可</h6>
                                                </b-col>
                                                <b-col cols="auto">
                                                    <b-form-checkbox v-model="model.values.ebay.return_policy.international_returns_accepted_option" switch />
                                                </b-col>
                                            </b-row>
                                            <template v-if="model.values.ebay.return_policy.international_returns_accepted_option">
                                               <div class="mt-2">返品期限</div>
                                               <SelectBase
                                                   v-model="model.values.ebay.return_policy.international_returns_within_option"
                                                   :options="ebay.international_returns_within_options"
                                                   size="sm"
                                                   />

                                               <div class="mt-2">返送料負担</div>
                                               <SelectBase
                                                   v-model="model.values.ebay.return_policy.international_shipping_cost_paid_by_option"
                                                   :options="ebay.international_shipping_cost_paid_by_options"
                                                   size="sm"
                                                   />

                                               <div class="mt-2">返金方法</div>
                                               <SelectBase
                                                   v-model="model.values.ebay.return_policy.international_refund_option"
                                                   :options="ebay.international_refund_options"
                                                   size="sm"
                                                   />
                                            </template>
                                        </b-card>

                                        <div class="border-top my-4"></div>

                                        <h6 class="font-weight-bold">除外された場所(任意)</h6>
                                        <SelectCountryRegion
                                            v-model="model.values.ebay.shipping_details.exclude_ship_to_location"
                                            :reduce="v => v.value"
                                            :exclude="[ 'Worldwide', ]"
                                            multiple
                                            />
                                    </b-card>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row align-h="center">
                    <b-col md="8" lg="4">
                        <br>
                        <b-button variant="primary" size="lg" block @click="
                            ebay.is_bulk_listing = false;
                            $refs.modal.save();">
                            <template v-if="!model._.is_enabled_schedule">即時出品する</template>
                            <template v-else>予約出品する</template>
                        </b-button>
                        <br>
<!--
                        <b-button variant="primary" size="lg" block @click="
                            ebay.is_enabled_schedule = false;
                            ebay.is_bulk_listing = true;
                            $refs.modal.save();
                            ">あとで一括出品する</b-button>
-->
<!--
                        <br>
                        <b-button variant="primary" size="lg" block v-b-modal.modal-list-schedule>予約出品する</b-button>
                        <b-modal id="modal-list-schedule" title="予約出品する" hide-footer>
                            <b-row>
                                <b-col cols="12" sm="6">
                                    タイムゾーン
                                    <SelectBase
                                        v-model="ebay.schedule_time_zone"
                                        :options="ebay.time_zones"
                                        @input="onInputEbayScheduleTimeZone"
                                        class="mb-3"
                                        />
                                </b-col>
                                <b-col cols="12" sm="6">
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="6">
                                    日にち
                                    <b-input-group class="mb-3">
                                        <b-form-input
                                            v-model="ebay.schedule_time_date"
                                            type="text"
                                            placeholder="YYYY-MM-DD"
                                            autocomplete="off"
                                            ></b-form-input>
                                        <b-input-group-append>
                                            <b-form-datepicker
                                                v-model="ebay.schedule_time_date"
                                                button-only
                                                right
                                                :start-weekday="1"
                                                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow', }"
                                                @context="onContextEbayScheduleTimeDate"
                                                />
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
                                <b-col cols="12" sm="6">
                                    時間
                                    <b-input-group class="mb-3">
                                        <b-form-input
                                            v-model="ebay.schedule_time_time"
                                            type="text"
                                            placeholder="HH:mm"
                                            />
                                        <b-input-group-append>
                                            <b-form-timepicker
                                                v-model="ebay.schedule_time_time"
                                                button-only
                                                right
                                                locale="en"
                                                :hour12="false"
                                                @context="onContextEbayScheduleTimeTime"
                                                />
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
                            </b-row>

                            {{ model.values.ebay.schedule_time }}
                            <span
                                class="text-danger"
                                v-if="!model.values.ebay.schedule_time"
                                >
                                有効な日時を入力してください。
                            </span>

                            <b-button variant="primary" size="lg" block class="mt-5 mb-3" @click="ebay.is_enabled_schedule = true; $refs.modal.save()" :disabled="!model.values.ebay.schedule_time">予約出品する</b-button>
                        </b-modal>
-->
                        <br>
                        <br>
                    </b-col>
                </b-row>
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import SelectBase from '@/components/SelectBase.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemDataAmazon from '@/components/ItemDataAmazon.vue'
import ItemDataEbay from '@/components/ItemDataEbay.vue'
import ItemDataWoo from '@/components/ItemDataWoo.vue'
import ItemCategory from '@/components/ItemCategory.vue'
import ItemSpecifics from '@/components/ItemSpecifics.vue'
import FileImageDrop from '@/components/FileImageDrop.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'
import SelectCountry from '@/components/SelectCountry.vue'
import SelectCountryRegion from '@/components/SelectCountryRegion.vue'
import LogTable from '@/components/LogTable.vue'
import HtmlEditorWzPreview from '@/components/HtmlEditorWzPreview.vue'
import MeListingListItem from '@/components/MeListingListItem.vue'

export default {
    components: {
        GridPage,
        FormModal,
        SelectBase,
        ItemBadges,
        InputError,
        ItemDataAmazon,
        ItemDataEbay,
        ItemDataWoo,
        ItemCategory,
        ItemSpecifics,
        FileImageDrop,
        SelectCountry,
        SelectCountryRegion,
        LogTable,
        HtmlEditorWzPreview,
        MeListingListItem,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
        response: {
            type: Object,
            default() {
                return {}
            },
        }
    },
    data() {
        return {
//            timer: null,
            key: 0,
            tabIndex: 0,
            tabIndexMax: 2,
            _: {
                preview_description: null,
                schedule_time_default: '+2days2000',
//                step_1_open: false,
//                load_last_listing: false,
//                is_enabled_schedule: false,
            },

            ebay: {
                sku_prefix: '',
                sku_number: '',
                sku_cost: '',

                conditions: [],
                listing_types: [
//                    { value: 'Chinese', text: 'オークション', },
//                    { value: 'FixedPriceItem', text: '今すぐ落札', },
                ],
                listing_durations: {},
                is_bulk_listing: false,
                time_zones: [
                    { value: '+0900', text: 'JST 日本標準時', },
                    { value: '-0800', text: 'PST 米国太平洋標準時', },
                    { value: '+0000', text: 'GMT グリニッジ標準時', },
                ],
                schedule_time_date: '',
                schedule_time_time: '',
                schedule_time_zone: '-0800',
                shipping_types: [
                    { value: 'FLAT_RATE', text: '通常配送：小～中サイズの商品', },
                    { value: 'FREIGHT_RATE', text: '貨物便：特大サイズの商品', },
                    { value: 'NOT_SPECIFIED', text: '近所で受け取り：近くの購入者に販売', },
                ],
                shipping_domestic_services: [
                ],
                shipping_international_services: [
                ],
                domestic_shipping_types: [
                    { value: 'Flat', text: '定額料金：購入者の住所にかかわらず同額', },
                    { value: 'Calculated', text: '算定：購入者の住所によって費用が異なります', },
                ],
                international_shipping_types: [
                    { value: 'Flat', text: '定額料金：購入者の住所にかかわらず同額', },
                    { value: 'Calculated', text: '算定：購入者の住所によって費用が異なります', },
                ],
                dispatch_time_max: [
                    { value: '0', text: '当日営業日', },
                    { value: '1', text: '1営業日', },
                    { value: '2', text: '2営業日', },
                    { value: '3', text: '3営業日', },
                    { value: '4', text: '4営業日', },
                    { value: '5', text: '5営業日', },
                    { value: '6', text: '6営業日', },
                    { value: '7', text: '7営業日', },
                    { value: '10', text: '10営業日', },
                    { value: '15', text: '15営業日', },
                    { value: '20', text: '20営業日', },
                    { value: '30', text: '30営業日', },
                    { value: '40', text: '40営業日', },
                ],
                returns_within_options: [
                    { value: 'Days_30', text: '30日', },
                    { value: 'Days_60', text: '60日', },
                ],
                shipping_cost_paid_by_options: [
                    { value: 'Buyer', text: '購入者', },
                    { value: 'Seller', text: '購入者は無料、出品者が負担', },
                ],
                refund_options: [
                    { value: 'MoneyBack', text: '返金', },
                    { value: 'MoneyBackOrReplacement', text: '返金または代替品', },
                ],
                international_returns_within_options: [
                    { value: 'Days_14', text: '14日', },
                    { value: 'Days_30', text: '30日', },
                    { value: 'Days_60', text: '60日', },
                ],
                international_shipping_cost_paid_by_options: [
                    { value: 'Buyer', text: '購入者', },
                    { value: 'Seller', text: '購入者は無料、出品者が負担', },
                ],
                international_refund_options: [
                    { value: 'MoneyBack', text: '返金', },
                    { value: 'MoneyBackOrReplacement', text: '返金または代替品', },
                ],
            },
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'auth_user',
            'trans',
        ])
    },
    mounted() {
//        this.timer = window.setInterval(this.interval, 10 * 1000)
//        this.interval()
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        capture(event) {
console.log('capture', event)

const reader = new FileReader()

// 選択されたファイルの取得
const file = event.target.files[0]

// ファイルが選択されていればBase64に変換する
if (file) {
    reader.readAsDataURL(file)
} else {
//    this.previewBase64 = ''
}

// 変換が終わったら実行される
reader.onload = () => {
    console.log(this.photos)
    console.log(reader)
    this.model.values.ebay.photos.push(reader.result)
//    this.previewBase64 = reader.result
}
        },

        onInputTabs() {
            document.querySelector('.modal-body').scrollTop = 0
        },

        onInputConditionId() {
            this.$utils.empty(this.model.values.ebay.condition_descriptors)

            for (let i = 0; i < this.ebay.conditions.length; i++) {
                const condition = this.ebay.conditions[i]
                if (condition.value === this.model.values.ebay.condition_id) {
                    if (!condition.conditionDescriptors) {
                        break
                    }
                    for (let j = 0; j < condition.conditionDescriptors.length; j++) {
                        const condition_descriptor = condition.conditionDescriptors[j]
                        this.model.values.ebay.condition_descriptors.push(condition_descriptor)
                    }
                    break
                }
            }
//            this.$utils.set(this.model.values.ebay.condition_descriptors)
        },
        onContextEbayScheduleTimeDate() {
            this.buildEbayScheduleTime()
        },
        onContextEbayScheduleTimeTime() {
            this.buildEbayScheduleTime()
        },
        onInputEbayScheduleTimeZone() {
            if (this.model.values.ebay.schedule_time) {
                this.model.values.ebay.schedule_time
                    .utcOffset(this.ebay.schedule_time_zone)
                this.parseEbayScheduleTime(this.model.values.ebay.schedule_time)
            }
        },
        buildEbayScheduleTime() {
            this.model.values.ebay.schedule_time = ''

            if (!this.ebay.schedule_time_zone) {
                return
            }
            if (!this.ebay.schedule_time_date) {
                return
            }
            if (!this.ebay.schedule_time_time) {
                return
            }

            const time = this.$moment(this.ebay.schedule_time_date + 'T' + this.ebay.schedule_time_time + this.ebay.schedule_time_zone)
            if (time.isValid()) {
                this.model.values.ebay.schedule_time = time
            }
        },
        parseEbayScheduleTime(moment_time) {
            this.ebay.schedule_time_zone = moment_time.format('Z').replace(':', '')
            this.ebay.schedule_time_date = moment_time.format('YYYY-MM-DD')
            this.ebay.schedule_time_time = moment_time.format('HH:mm:ss')
        },
        async onClickScheduledOffset(item, seconds) {
            let time = null
console.log('onClickScheduledOffset')
            if (item === this.$data._.schedule_time_default) {
                time = this.$moment(this.$moment().add(2, 'd').format('YYYY-MM-DD') + 'T20:00-0800')
                    .utcOffset(this.ebay.schedule_time_zone)
            } else {
                time = this.$moment(item.ListingDetails.StartTime)
                    .add(seconds, 'seconds')
                    .utcOffset(this.ebay.schedule_time_zone)
            }
            this.model.values.ebay.schedule_time = time

            this.parseEbayScheduleTime(time)

            if (item.ItemID) {
               let ebay_item = await this.$store.dispatch('listing/get_ebay_item', item.ItemID)
                   .then((resposne) => {
                       return resposne.data.data
                   })
               this.loadStep3(ebay_item)
            }
        },
/*
        toggleSyncedSwitch(item) {
            if (item.synced) {
                this.$set(this.model.user_item_caches, item.provider, item)
            } else {
                this.$delete(this.model.user_item_caches, item.provider)
            }
            this.interval()
        },
        filterSearchResults(response) {
            this.interval()
            return response
        },
        changeBigFilter() {
            this.$refs.gridPageInventory.grid.filters.country = this.filters.country
            this.$refs.gridPageStore.grid.filters.country = this.filters.country

            console.log(this.$refs.gridPageInventory.search())
            console.log(this.$refs.gridPageStore.search())
        },
        interval() {
            if (!this.model.user_item_caches) {
                return
            }

            this.setStateToggleSyncedSwitch()
        },
        getSkusToggleSyncedSwitch() {
            const skus = []
            const keys = Object.keys(this.model.user_item_caches)
            for (let i = 0; i < keys.length; i++) {
                skus.push(this.model.user_item_caches[keys[i]].provider + ':' + this.model.user_item_caches[keys[i]].sku)
            }
            return skus
        },
        getUuidsToggleSyncedSwitch() {
            const uuids = []
            const keys = Object.keys(this.model.user_item_caches)
            for (let i = 0; i < keys.length; i++) {
                uuids.push(this.model.user_item_caches[keys[i]].uuid)
            }
            return uuids
        },
        setStateToggleSyncedSwitch() {
            const uuids = this.getUuidsToggleSyncedSwitch()

            // synced
            const keys = Object.keys(this.model.user_item_caches)
            for (let i = 0; i < keys.length; i++) {
                this.$set(this.model.user_item_caches[keys[i]], 'synced', true)
            }

            // grid
            if (this.$refs.gridPageInventory.grid.response.data) {
                for (let i = 0; i < this.$refs.gridPageInventory.grid.response.data.hits.length; i++) {
                    this.$set(this.$refs.gridPageInventory.grid.response.data.hits[i], 'synced', uuids.indexOf(this.$refs.gridPageInventory.grid.response.data.hits[i].uuid) >= 0)
                }
            }
            if (this.$refs.gridPageStore.grid.response.data) {
                for (let i = 0; i < this.$refs.gridPageStore.grid.response.data.hits.length; i++) {
                    this.$set(this.$refs.gridPageStore.grid.response.data.hits[i], 'synced', uuids.indexOf(this.$refs.gridPageStore.grid.response.data.hits[i].uuid) >= 0)
                }
            }
        },
*/
        async onInputCategoryId () {
            let category = await this.$store
                .dispatch('item_category/search', {
                    provider: 'ebay',
                    query: this.model.values.ebay.category_id,
                })
                .then((response) => {
                    return response.data.data.hits
                })
                .catch((error) => {
                    return []
                })
            if (category.length) {
                // item_specifics
                this.$utils.empty(this.model.values.ebay.item_specifics)
                this.$utils.set(this.model.values.ebay.item_specifics, category[0].value.aspects)

                // condition_id
                this.$utils.empty(this.ebay.conditions)
                this.$utils.set(
                    this.ebay.conditions,
                    (category[0].value.conditions || [])
                        .map((v) => {
                            return {
                                value: v.conditionId,
                                text: v.conditionDescription,
                                conditionDescriptors: v.conditionDescriptors,
                            }
                        })
                        .sort((a, b) => {
                            return (a.value > b.value) ? 1 : -1;
                        })
                )

                // listing_types
                this.$utils.empty(this.ebay.listing_types)
                this.$utils.set(
                    this.ebay.listing_types,
                    category[0].value.features.ListingDurations
                        .map((v) => {
                            return {
                                value: v.type,
                                text: this.trans.labels['listings.listing_type.' + v.type],
                            }
                        })
                )

                // listing_durations
                this.$utils.empty(this.ebay.listing_durations)
                this.$utils.set(
                    this.ebay.listing_durations,
                    this.$utils.keyBy(category[0].value.features.ListingDurations, 'type')
                )
                if (this.ebay.listing_durations.Chinese) {
                    this.ebay.listing_durations.Chinese.value.Duration.unshift('Days_1')
                }
            }
        },
        async onClickPreviewDescription() {
            console.log('onClickPreviewDescription')
            let res = await this.$store
                .dispatch('listing/preview_description', {
                    html: this.model.values.ebay.description,
                })
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    return null
                })
            this.$data._.preview_description = res
        },

        beforeSaving (model) {
            let data = this.$utils.copy(model)

            if (!this.model._.is_enabled_schedule) {
                data.values.ebay.schedule_time = ''
            }

            data.is_bulk_listing = this.ebay.is_bulk_listing

            return data
        },
        onSetIsEditMode (model) {
            if (model.is_edit_mode) {
                if (model.images.length) {
                    setTimeout(() => {
                        this.fixImage(model.images[0])
                    }, 1000)
                }
            }
        },
        gr2lbsoz (gr) {
            let oz = Math.ceil(0.0352739619496 * gr)
            let lbs = Math.floor(oz / 16)
            return lbs + ' lbz ' + (oz - 16 * lbs) + ' oz'
        },
        cm2inch (cm) {
            return Math.ceil(0.393701 * cm * 100) / 100
        },
        buildSku () {
            this.model.values.ebay.sku = [
                this.ebay.sku_prefix || false,
                /^[0-9]+$/.test(this.ebay.sku_number) ? ('' + Number(this.ebay.sku_number)) : false,
                /^[0-9]+$/.test(this.ebay.sku_cost) ? ('\\' + Number(this.ebay.sku_cost)) : false,
            ]
                .filter((v) => {
                    return v !== false;
                })
                .join('_');
        },

        loadPolicyForStep3 () {
            this.loadPolicyForStep3Shipping()
            this.loadPolicyForStep3Payment()
            this.loadPolicyForStep3Return()
        },
        loadPolicyForStep3Shipping () {
            axios
                .get('/api/v1/test/ebayGetFulfillmentPolicy', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        loadPolicyForStep3Payment () {
            axios
                .get('/api/v1/test/ebayGetPaymentPolicy', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        loadPolicyForStep3Return () {
            axios
                .get('/api/v1/test/ebayGetReturnPolicy', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        loadPolicyForStep3Db () {
            // 配送 ---------------------------------
            // US向け
//            this.model.values.ebay.shipping_details.shipping_service_options
            // US以外向け
//            this.model.values.ebay.shipping_details.international_shipping_service_option

            // 環境設定 -----------------------------
            // 発送準備期間
//            this.model.values.ebay.dispatch_time_max
            // 発送元
//            this.model.values.ebay.country
//            this.model.values.ebay.location
//            // 返品 ---------
//            //USで購入された商品の返品を許可
//            this.model.values.ebay.return_policy.returns_accepted_option
//            this.model.values.ebay.return_policy.returns_within_option
//            this.model.values.ebay.return_policy.shipping_cost_paid_by_option
//            this.model.values.ebay.return_policy.refund_option
//            //US以外で購入された商品の返品を許可
//            this.model.values.ebay.return_policy.international_returns_accepted_option
//            this.model.values.ebay.return_policy.international_returns_within_option
//            this.model.values.ebay.return_policy.international_shipping_cost_paid_by_option
//            this.model.values.ebay.return_policy.international_refund_option
            // 除外された場所(任意)
//            this.model.values.ebay.shipping_details.exclude_ship_to_location
        },
        loadStep2 (ebay_item, naming_convention = 'pascal', is_clear = false) {
            let fn = null;
            switch (naming_convention) {
                case 'pascal':
                    fn = (v) => v;
                    break;
                case 'snake':
                    fn = (v) => this.$utils.toNamingConvention(v, 'pascal', 'snake');
                    break;
                default:
                    fn = (v) => v;
                    break;
            }

            // 説明 ---------------------------------
            this.model.values.ebay.description = is_clear ? '' : ebay_item[fn('Description')];

            // 価格 ---------------------------------
            this.model.values.ebay.listing_type = is_clear ? 'Chinese' : ebay_item[fn('ListingType')];
            this.model.values.ebay.listing_duration = is_clear ? 'Days_7' : ebay_item[fn('ListingDuration')];
            if (this.model.values.ebay.listing_type === 'Chinese') {
                this.model.values.ebay.start_price = is_clear ? '' :ebay_item[fn('StartPrice')];
                this.model.values.ebay.buy_it_now_price = is_clear ? '' : ebay_item[fn('BuyItNowPrice')];
                this.model.values.ebay.reserve_price = is_clear ? '' : ebay_item[fn('ReservePrice')];
            } else {
                this.model.values.ebay.start_price = '';
            }
            this.model.values.ebay.quantity = 1;

console.log(ebay_item);
//console.log(this.auth_user);
            // オファー ---------------------------------
            this.model.values.ebay.best_offer_details.best_offer_enabled = is_clear ? false : ebay_item[fn('BestOfferDetails')][fn('BestOfferEnabled')];
            this.model.values.ebay.listing_details.minimum_best_offer_price = is_clear ? '' : ebay_item[fn('ListingDetails')][fn('MinimumBestOfferPrice')];
            this.model.values.ebay.listing_details.best_offer_auto_accept_price = is_clear ? '' : ebay_item[fn('ListingDetails')][fn('BestOfferAutoAcceptPrice')];

            // 出品日時を指定 ---------------------------------
            this.model._.is_enabled_schedule = is_clear ? false : this.auth_user.last_listing_ebay._.is_enabled_schedule;
            if (this.model._.is_enabled_schedule) {
                this.model._.schedule_time = is_clear ? '' : ebay_item[fn('ScheduleTime')];
                this.parseEbayScheduleTime(this.$moment(this.model._.schedule_time));
                this.ebay.schedule_time_zone = '-0800';
                this.onInputEbayScheduleTimeZone();
            }
        },
        loadStep3 (ebay_item, naming_convention = 'pascal', is_clear = false) {
            let fn = null;
            switch (naming_convention) {
                case 'pascal':
                    fn = (v) => v;
                    break;
                case 'snake':
                    fn = (v) => this.$utils.toNamingConvention(v, 'pascal', 'snake');
                    break;
                default:
                    fn = (v) => v;
                    break;
            }

            // 配送 ---------------------------------
            // US向け
            if (is_clear) {
                this.model.values.ebay.shipping_details.shipping_service_options = [
                    {
                        ship_to_location: [ 'US', ],
                        shipping_service: 'EconomyShippingFromOutsideUS',
                        shipping_service_cost: { value: 1, },
                        shipping_service_additional_cost: { value: 0, },
                    },
                    {
                        ship_to_location: [ 'US', ],
                        shipping_service: 'StandardShippingFromOutsideUS',
                        shipping_service_cost: { value: 5, },
                        shipping_service_additional_cost: { value: 5, },
                    },
                    {
                        ship_to_location: [ 'US', ],
                        shipping_service: 'ExpeditedShippingFromOutsideUS',
                        shipping_service_cost: { value: 20, },
                        shipping_service_additional_cost: { value: 20, },
                    },
                ];
            } else {
                this.model.values.ebay.shipping_details.shipping_service_options.splice(0)
                for (let i = 0; i < ebay_item[fn('ShippingDetails')][fn('ShippingServiceOptions')].length; i++) {
                    const option = ebay_item[fn('ShippingDetails')][fn('ShippingServiceOptions')][i]
                    this.model.values.ebay.shipping_details.shipping_service_options.push({
                        ship_to_location: [ 'US', ],
                        shipping_service: option[fn('ShippingService')],
                        shipping_service_cost: { value: option[fn('ShippingServiceCost')].value },
                        shipping_service_additional_cost: { value: option[fn('ShippingServiceAdditionalCost')] ? option[fn('ShippingServiceAdditionalCost')].value : 0, },
                    })
                }
            }

            // US以外向け
            if (is_clear) {
                this.model.values.ebay.shipping_details.international_shipping_service_option = [
                    {
                        ship_to_location: [ 'Worldwide', ],
                        shipping_service: 'OtherInternational',
                        shipping_service_cost: { value: 1, },
                        shipping_service_additional_cost: { value: 0, },
                    },
                    {
                        ship_to_location: [ 'Worldwide', ],
                        shipping_service: 'StandardInternational',
                        shipping_service_cost: { value: 5, },
                        shipping_service_additional_cost: { value: 5, },
                    },
                    {
                        ship_to_location: [ 'Worldwide', ],
                        shipping_service: 'ExpeditedInternational',
                        shipping_service_cost: { value: 20, },
                        shipping_service_additional_cost: { value: 20, },
                    },
                ];
            } else {
                this.model.values.ebay.shipping_details.international_shipping_service_option.splice(0)
                for (let i = 0; i < ebay_item[fn('ShippingDetails')][fn('InternationalShippingServiceOption')].length; i++) {
                    const option = ebay_item.[fn('ShippingDetails')][fn('InternationalShippingServiceOption')][i]
                    this.model.values.ebay.shipping_details.international_shipping_service_option.push({
                        ship_to_location: option[fn('ShipToLocation')],
                        shipping_service: option[fn('ShippingService')],
                        shipping_service_cost: { value: option[fn('ShippingServiceCost')].value },
                        shipping_service_additional_cost: { value: option[fn('ShippingServiceAdditionalCost')] ? option[fn('ShippingServiceAdditionalCost')].value : 0, },
                    })
                }
            }

            // 環境設定 -----------------------------
            // 発送準備期間
            this.model.values.ebay.dispatch_time_max = is_clear ? '3' : ebay_item[fn('DispatchTimeMax')] + ''
            // 発送元
            this.model.values.ebay.country = is_clear ? 'JP' : ebay_item[fn('Country')]
            this.model.values.ebay.location = is_clear ? 'Tokyo' : ebay_item[fn('Location')]

            // 返品 ---------
            //USで購入された商品の返品を許可
            this.model.values.ebay.return_policy.returns_accepted_option = is_clear ? '' : ebay_item[fn('ReturnPolicy')][fn('ReturnsAcceptedOption')] === 'ReturnsAccepted'
            this.model.values.ebay.return_policy.returns_within_option = is_clear ? '' : ebay_item[fn('ReturnPolicy')][fn('ReturnsWithinOption')]
            this.model.values.ebay.return_policy.shipping_cost_paid_by_option = is_clear ? '' : ebay_item[fn('ReturnPolicy')][fn('ShippingCostPaidByOption')]
            this.model.values.ebay.return_policy.refund_option = is_clear ? '' : ebay_item[fn('ReturnPolicy')][fn('RefundOption')]
            //US以外で購入された商品の返品を許可
            this.model.values.ebay.return_policy.international_returns_accepted_option = is_clear ? '' : ebay_item[fn('ReturnPolicy')][fn('InternationalReturnsAcceptedOption')] === 'ReturnsAccepted'
            this.model.values.ebay.return_policy.international_returns_within_option = is_clear ? '' : ebay_item[fn('ReturnPolicy')][fn('InternationalReturnsWithinOption')]
            this.model.values.ebay.return_policy.international_shipping_cost_paid_by_option = is_clear ? '' : ebay_item[fn('ReturnPolicy')][fn('InternationalShippingCostPaidByOption')]
            this.model.values.ebay.return_policy.international_refund_option = is_clear ? '' : ebay_item[fn('ReturnPolicy')][fn('InternationalRefundOption')]
            // 除外された場所(任意)
            this.model.values.ebay.shipping_details.exclude_ship_to_location = is_clear ? [] : ebay_item[fn('ShippingDetails')][fn('ExcludeShipToLocation')]
        },
        onShown () {
            console.log('onShown');

            // TODO
            // if (oncopy) { return }

            if (this.auth_user.last_listing_ebay) {
                this.model._.load_last_listing = this.auth_user.last_listing_ebay._.load_last_listing
            }
            if (this.model._.load_last_listing) {
                this.onChangeLoadLastListing();
            }
        },
        onChangeLoadLastListing () {
            if (!this.auth_user.last_listing_ebay) {
                return
            }

//            if (!this.model._.load_last_listing) {
//                // TODO:
////                clear step2
////                clear step3
//                return
//            }

            this.loadStep2(this.auth_user.last_listing_ebay.values.ebay, 'snake', !this.model._.load_last_listing);
            this.loadStep3(this.auth_user.last_listing_ebay.values.ebay, 'snake', !this.model._.load_last_listing);
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
</style>

